module.exports = __webpack_public_path__ + "static/media/region.b559678d.png";